import { setSourceId } from '../common/sharedFunctions';
import {
  NO,
  YES,
} from '../constants/constants';
import bannerConstants, { UNSUBSCRIBE_MESSAGES, SUBSCRIBE_MESSAGES } from '../constants/bannerConstants';

export const isSsr = typeof window === 'undefined';

export function isLoggedIn() {
  return isSsr ? false : (window.THDCustomer?.default?.isLoggedIn || false);
}

export function isB2bUser() {
  return window?.THDCustomer?.default?.isB2BCustomer;
}

export function isNewB2cLink() {
  // todo use config service
  return isSsr
    ? false
    : window?.__EXPERIENCE_PROPS__?.expConfiguration?.ENABLE_NEW_B2C_PREFERENCE_LINK === 'true';
}

export function setupAutoResizer(channel, setIsMobile) {
  const getWidth = () => document.documentElement.clientWidth
    || document.body.clientWidth
    || window?.innerWidth;

  const isMobileWidth = () => {
    return getWidth() <= 640;
  };

  const mobileCondition = (channel === 'mobile' || isMobileWidth());

  setIsMobile(mobileCondition);
  setSourceId(channel);

  const resizeListener = () => {
    if (channel !== 'mobile') {
      setIsMobile(isMobileWidth());
    }
  };
  window.addEventListener('resize', resizeListener);

  return () => {
    window.removeEventListener('resize', resizeListener);
  };
}

export const formatPhoneIntake = (val) => {
  if (!val) return '';
  const newNumber = val.replace(/\D/g, '');
  return newNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export function formatEmailIntake(val) {
  if (!val) {
    return '';
  }
  return val.trim().toLowerCase();
}

export function formatAddressIntake(val) {
  if (!val || !val.addressLine1) {
    return '';
  }
  const addr1and2 = val.addressLine2
    ? val.addressLine1 + ' ' + val.addressLine2 + ', '
    : val.addressLine1 + ', ';
  const address = [
    val.city,
    val.state,
  ].filter(Boolean);
  return addr1and2 + address.join(', ') + ' ' + val.zip5;
}

export function formatIntake(intake) {
  if (typeof intake === 'string' && intake.includes('.') && intake.includes('@')) {
    return formatEmailIntake(intake);
  } if (typeof intake === 'object' && intake.addressLine1) {
    return formatAddressIntake(intake);
  }
  return formatPhoneIntake(intake);
}

export function determineMessage(selectedItems, emailTableData) {
  const newSelectedOptOuts = selectedItems
    .filter((key) => emailTableData[key].value === NO)
    .map((key) => emailTableData[key].type);

  const newSelectedOptIns = selectedItems
    .filter((key) => emailTableData[key].value === YES)
    .map((key) => emailTableData[key].type);

  const messages = [];

  newSelectedOptOuts.forEach((type) => {
    if (UNSUBSCRIBE_MESSAGES[type]) {
      messages.push(UNSUBSCRIBE_MESSAGES[type]);
    }
  });

  newSelectedOptIns.forEach((type) => {
    if (SUBSCRIBE_MESSAGES[type]) {
      messages.push(SUBSCRIBE_MESSAGES[type]);
    }
  });

  return messages.length > 0 ? messages : [bannerConstants.PREFERENCES_UPDATED];
}
